<template>
  <div id="contact-me" :class="sectionClass">
    <h4 class="red">Contact</h4>
    <p>For commercial projects, commissions or press enquiries:</p>

    <p class="red">
      <a href="mailto:hello@nathanandfriends.net"
        >hello@nathanandfriends.net</a
      ></p
    >
  </div>
</template>

<script>
import { isMobile } from '@/helpers'

export default {
  computed: {
    sectionClass() {
      return {
        section: !this.isMobile(),
        sectionMobile: this.isMobile(),
      }
    },
  },
  methods: {
    isMobile,
  },
}
</script>

<style lang="scss" scoped>
.section {
  padding: 10% 0% 10%;
}

.sectionMobile {
  padding: 12% 0% 32%;
  font-size: small;
}
</style>



// WEBPACK FOOTER //
// src/components/about-me/AboutMeContact.vue